const React = require('react');
const {
  getRFC3339,
} = require('mn-utils/formatTime');
const {
  backLocation,
} = require('../../../../router');
const formatTime = require('../../../../utils/formatTime');
const formatNumFiat = require('../../../../utils/formatNumFiat');
const formatNumCoin = require('../../../../utils/formatNumCoin');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');
const {
  apiAdminFailedAuctionsList,
} = require('../../../../api/admin/failedAuctions');
const {default: ArrowBackIcon} = require('@material-ui/icons/ArrowBack');
const ButtonD = require('../../../dumb/Button/D');


module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: apiAdminFailedAuctionsList,
  getParams: (self) => {
    return {
      id: (self.props.params || {}).id,
    };
  },
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const id = data.id;
      const ccCode = data.cc_code;
      const ccValue = data.cc_value;
      const scCode = data.sc_code;
      const scValue = data.sc_value;
      const exchangeRate = data.exchange_rate || 0;
      const time = data.time || '';
      const difference = data.difference || 0;

      return (
        <RowA className="f12">
          <ColA className="w(|min)110">
            <Tooltip>{id}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip
              title={getRFC3339(time)}
            >{formatTime(time)}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.merchant}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.merchant_login}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.arbitrator}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.arbitrator_login}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.exchange}</Tooltip>
          </ColA>
          <ColA className="w(|min)110">
            <Tooltip>{data.exchange_name}</Tooltip>
          </ColA>
          <ColA className="w(|min)80">
            <Tooltip
              className="fhaE*2"
              title={ccValue}
            >{formatNumCoin(ccValue)}</Tooltip>
          </ColA>
          <ColA className="w(|min)80">
            <Tooltip>{ccCode}</Tooltip>
          </ColA>
          <ColA className="w(|min)80">
            <Tooltip
              className="fhaE*2"
              title={scValue}
            >{formatNumFiat(scValue)}</Tooltip>
          </ColA>
          <ColA className="w(|min)80">
            <Tooltip>{scCode}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.auction_status}</Tooltip>
          </ColA>
          <ColA className="w(|min)80">
            <Tooltip
              className="fhaE*2"
              title={exchangeRate}
            >{formatNumFiat(exchangeRate)}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.payment_status}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.tx_hash}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.order_status}</Tooltip>
          </ColA>
          <ColA className="wmin100 fx1">
            <Tooltip
              className="fhaE*2"
              title={difference}
            >{formatNumCoin(difference)}</Tooltip>
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Failed auctions</CaptionA>
            <ButtonD onClick={backLocation}>
              <ArrowBackIcon/>
              <div className="pl15">Back</div>
            </ButtonD>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45">
              <div className="wmin1800 rlv h">
                <div>
                  <RowB className="f12">
                    <ColB className="w(|min)110">ID</ColB>
                    <ColB className="w(|min)110">Date & Time</ColB>
                    <ColB className="w(|min)110">Merchant</ColB>
                    <ColB className="w(|min)110">Merchant<br/>login</ColB>
                    <ColB className="w(|min)110">Arbitrator</ColB>
                    <ColB className="w(|min)110">Arbitrator<br/>login</ColB>
                    <ColB className="w(|min)110">Exchange</ColB>
                    <ColB className="w(|min)110">Exchange<br/>name</ColB>
                    <ColB className="w(|min)80">CC Value</ColB>
                    <ColB className="w(|min)80">CC Code</ColB>
                    <ColB className="w(|min)80">SC Value</ColB>
                    <ColB className="w(|min)80">SC Code</ColB>
                    <ColB className="w(|min)100">Auction<br/>status</ColB>
                    <ColB className="w(|min)80">Rate</ColB>
                    <ColB className="w(|min)100">Payment<br/>status</ColB>
                    <ColB className="w(|min)100">Transaction</ColB>
                    <ColB className="w(|min)100">Order<br/>status</ColB>
                    <ColB className="wmin100 fx1">Difference</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
